import { Consent } from '@witkac/kartamiejska-shared';
import { ConsentResource, consentResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Modół zgód
 *
 * @export
 * @class ConsentModule
 * @extends {EntityModule<Consent, ConsentResource>}
 */
export class ConsentModule extends EntityModule<Consent, ConsentResource> {
  constructor() {
    super(consentResource);
  }
}

export default new ConsentModule();
